import React from "react";
import { Link } from "react-router-dom";
import { Ticket } from "lucide-react";

const PublicFooter = ({ salonSlug }) => {
  const links = salonSlug
    ? [
        { to: "/", label: "Inicio" },
        { to: "/explorar", label: "Explorar" },
        { to: `/${salonSlug}/support`, label: "Soporte" },
        { to: "/suport", label: "Ayuda PASSAR" },
      ]
    : [
        { to: "/", label: "Inicio" },
        { to: "/eventos", label: "Eventos" },
        { to: "/explorar", label: "Explorar" },
        { to: "/suport", label: "Soporte" },
      ];

  return (
    <footer className="relative z-10 mt-8 border-t border-white/5 bg-background/40 px-4 py-10 md:py-14">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
          <div className="text-center md:text-left">
            <Link to="/" className="inline-flex items-center justify-center gap-2 md:justify-start">
              <div className="w-9 h-9 bg-brand-gradient rounded-xl flex items-center justify-center shadow-lg shadow-orange-500/20">
                <Ticket className="text-white" size={18} />
              </div>
              <span className="font-black tracking-tighter text-2xl text-white">PASSAR</span>
            </Link>
            <p className="mt-4 max-w-md text-sm font-medium leading-relaxed text-white/35">
              Tecnología para eventos, accesos y experiencias digitales.
            </p>
          </div>

          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-[10px] font-black uppercase tracking-[2px] text-white/35 md:justify-end">
            {links.map((link) => (
              <Link key={`${link.to}-${link.label}`} to={link.to} className="hover:text-white transition-colors">
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-10 border-t border-white/5 pt-6 text-center md:text-left">
          <p className="text-[10px] font-black uppercase tracking-[3px] text-white/15 break-words">
            © {new Date().getFullYear()} PASSAR • LM-INGENIERÍA
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
